/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.977
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveCCBContractFees,
	getCCBContractFeesCreateInit,
	getCCBContractFeesEditInit,
	getCCBContractFeesView,
	deleteCCBContractFees
} from '@api/house/CCBContractFees';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getCCBContractFeesCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractFeesCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractFeesEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractFeesEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveCCBContractFees({}, CCBContractFees) {
			return new Promise((resolve, reject) => {
				saveCCBContractFees(CCBContractFees)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractFeesView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractFeesView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBContractFees({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBContractFees({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
